{
  "filter": "Filter",
  "filters": "Filters",
  "ok": "OK",
  "cancel": "Cancel",
  "close": "Close",
  "delete": "Delete",
  "update": "Update",
  "remove": {
    "user": "Delete user"
  },
  "search": "Search",
  "back": "Back",
  "validate": "Validate",
  "save": "Save",
  "archive": "Archive",
  "send": "Send",
  "disable": "Disable",
  "enable": "Enable",
  "create": {
    "_": "Create",
    "rootCa": "Load the root CA"
  },
  "next": "Next",
  "previous": "Previous",
  "test": {
    "pki": "Test connection"
  },
  "slider": {
    "enable": "Enable selection",
    "disable": "Disable selection"
  },
  "download": "Download",
  "add": "Add",
  "import": "Import",
  "retryLogin": "Try to log in again",
  "retryLogout": "Try to log out again",
  "confirm": "Confirm",
  "deactivate": "Deactivate",
  "activate": "Activate",
  "upload": "Upload",
  "copied": "Copied",
  "copiedTitle": "Copy to clipboard",
  "edit": "Edit"
}
